import { ValidationSchema, Validator } from "@bps/validator";
import { LicenceFormValues } from "modules/tenants/sections/plt/licencing/licence-form-dialog/LicenceFormDialog.types";

export const licenceFormValidator = new Validator<LicenceFormValues>();

export const licenceFormSchema: ValidationSchema<LicenceFormValues> = {
  licenceTypeCode: licenceFormValidator
    .string()
    .required({ message: "Licence type code is required" }),
  productId: licenceFormValidator
    .string()
    .required({ message: "Product is required" }),
  expiryDate: [
    licenceFormValidator.date().todayOrGreater(),
    licenceFormValidator.date().required({ message: "Expiry date is required" })
  ]
};
